import { Observable } from "rxjs";

import { get } from "@utils/axios";
import sessionService from "./session.service";


class HighIntensityCareMgmtService {

    getColumnsList() : Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=High Intensity CareTeam Dashboard`);
    }

    getHipMembers(taskStatus:any, registryValue:any) : Observable<any> {
        const reqParams = `${taskStatus ? `taskStatus=${taskStatus}&` : ""}${registryValue ? `registryValue=${registryValue}` : ""}`
        return get(`${sessionService.getClient()?.appServiceUrl}/care-coordination/dashboard-details?${reqParams}`);
    }

    getRegistryDropDown() : Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/care-coordination/dashboard-dropdown`);
    }
}

export default new HighIntensityCareMgmtService();
